import App from 'app/app.js';

function UIService($rootScope) {
  var fixSelectAndroidRender = function () {
    $('select').css({ border: 'none', 'border-style': 'none', 'border-radius': '0px' });
  };

  $rootScope.$on('$viewContentLoaded', function () {
    var nua = navigator.userAgent;
    var isAndroid =
      nua.indexOf('Mozilla/5.0') > -1 &&
      nua.indexOf('Android ') > -1 &&
      nua.indexOf('AppleWebKit') > -1 &&
      nua.indexOf('Chrome') === -1;
    if (isAndroid) {
      setTimeout(fixSelectAndroidRender, 0);
    }
  });
}

App.service('UIService', ['$rootScope', UIService]);
App.run(['UIService', function (UIService) {}]);
